/* Giftera – ține „Card personalizat” (produs ascuns, gratuit) sincronizat cu seturile personalizate din coș.
   Portat din tema live și extins (docs/SPEC-PDP.md §1): rulează pe orice pagină, la încărcare și la fiecare
   `cart-update` (evenimentul Ella), cu protecție la buclă. Nu blochează nimic dacă eșuează.

   Regula (aceeași ca în live): cantitatea liniei `card-personalizat` = suma cantităților liniilor care au
   proprietatea „Format card”; la 0, linia se șterge. Scriptul nu adaugă niciodată add-on-ul, doar îl corectează.
   Dacă în coș sunt mai multe linii add-on (seturi diferite → `Pentru` diferit), fiecare primește suma
   seturilor personalizate cu același titlu. Titlul unui set se poate schimba cât timp e în coș (redenumire,
   trecerea la variante): un add-on al cărui `Pentru` nu mai găsește niciun set nu se șterge cât există seturi
   personalizate nerevendicate de alt add-on.

   Pasul 7 (coș): butoanele de finalizare (#cart-sidebar-checkout din sertar, #cart-checkout de pe pagina de coș)
   așteaptă o ultimă verificare înainte de a pleca spre checkout, cel mult 4 s; dacă verificarea eșuează sau
   întârzie, checkout-ul pornește oricum. Pe pagina de coș, după o corecție se reîncarcă doar secțiunea
   (ca updateCart din Ella), nu toată pagina.

   Tot aici: `gf:cart-stale` (emis de getCartUpdate din global.js când Shopify răspunde cu eroare, dar a schimbat
   totuși coșul) reface pagina de coș din starea reală; după fiecare `cart-update`, totalul și textul barei de
   transport sunt scrise într-o regiune live persistentă (bara însăși e înlocuită cu tot fragmentul). */
(function () {
  if (window.__gfCartSync) return;
  window.__gfCartSync = true;

  var PROP = 'Format card';          // proprietate pusă de designer pe linia setului
  var HANDLE = 'card-personalizat';  // produsul ascuns
  var FLAG = 'gf-cart-synced';       // pagina de coș: o singură reîncărcare per corecție
  var CHECKOUT = '#cart-sidebar-checkout, #cart-checkout';
  var WAIT = 4000;                   // cât așteaptă cel mult un buton de checkout
  var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');

  var running = false;   // o sincronizare în curs
  var again = false;     // a venit un `cart-update` în timpul ei
  var muted = 0;         // până când ignorăm `cart-update` (cel provocat de propria corecție)
  var timer = null;
  var current = null;    // promisiunea sincronizării în curs
  var passing = false;   // clicul re-emis de garda de checkout
  var recent = [];       // momentele ultimelor corecții (frână de siguranță)
  var retry = null;      // reîncercarea programată când frâna a oprit o corecție
  var redraw = false;    // pagina de coș trebuie redesenată chiar dacă add-on-ul e în regulă (`gf:cart-stale`)

  function isCartPage() {
    return document.body.classList.contains('template-cart') || /\/cart\/?$/.test(window.location.pathname);
  }

  function isCustomSet(item) {
    return item.handle !== HANDLE && !!(item.properties && item.properties[PROP]);
  }

  /* Întoarce lista corecțiilor: [{ key, quantity }] */
  function plan(items) {
    var addons = items.filter(function (i) { return i.handle === HANDLE; });
    if (!addons.length) return [];
    var sets = items.filter(isCustomSet);
    var total = sets.reduce(function (n, i) { return n + i.quantity; }, 0);

    if (addons.length === 1) {
      return addons[0].quantity === total ? [] : [{ key: addons[0].key, quantity: total }];
    }
    var addonTotal = addons.reduce(function (n, i) { return n + i.quantity; }, 0);
    var wanted = addons.map(function (a) { return forTitle(sets, a); });
    var claimed = wanted.reduce(function (n, q) { return n + q; }, 0);
    if (addonTotal === total) {
      // un add-on fără set cu același titlu e în regulă doar dacă au rămas seturi nerevendicate (titlu schimbat)
      var ok = addons.every(function (a, k) { return wanted[k] === 0 ? claimed < total : a.quantity === wanted[k]; });
      if (ok) return [];
    }
    // totalurile nu se potrivesc: seturile nerevendicate merg la primul add-on rămas fără set, în loc să fie șters
    var orphan = total > claimed ? wanted.indexOf(0) : -1;
    if (orphan > -1) wanted[orphan] = total - claimed;
    return addons
      .map(function (a, k) { return { key: a.key, quantity: wanted[k], was: a.quantity }; })
      .filter(function (c) { return c.quantity !== c.was; });
  }

  function forTitle(sets, addon) {
    var title = addon.properties && addon.properties['Pentru'];
    return sets.reduce(function (n, i) {
      return n + (title && (i.product_title === title || i.title === title) ? i.quantity : 0);
    }, 0);
  }

  function post(body) {
    return fetch(root + '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function writeCount(cart) {
    var nodes = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = cart.item_count;
  }

  function announce(cart) {
    muted = Date.now() + 4000;
    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
  }

  function reloadPage() {
    try { sessionStorage.setItem(FLAG, '1'); } catch (e) { /* fără sessionStorage reîncărcăm oricum o dată */ }
    window.location.reload();
  }

  /* Pagina de coș: aceleași bucăți pe care le înlocuiește updateCart() din Ella (theme.js). */
  async function refreshCartPage() {
    var host = document.getElementById('main-cart-items');
    var id = host && host.getAttribute('data-id');
    if (!host || !id) { reloadPage(); return; }
    try {
      var cart = await (await fetch(root + '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })).json();
      if (!cart.item_count) { reloadPage(); return; }
      var res = await fetch(root + '/cart?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' });
      if (!res.ok) { reloadPage(); return; }
      var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      var pairs = ['[data-cart-content] .cart', '[data-cart-total] .cart-total-subtotal', '[data-cart-total] .cart-total-savings'];
      for (var i = 0; i < pairs.length; i++) {
        var fresh = doc.querySelector(pairs[i]);
        var old = host.querySelector(pairs[i]);
        if (!fresh || !old) { reloadPage(); return; }
        // handlerele Ella sunt delegate pe document, `cart-update-quantity` e custom element, iar
        // `window.cart_selling_array_*` există de la încărcare: scripturile inline nu trebuie reexecutate
        old.innerHTML = fresh.innerHTML;
      }
      var totals = host.querySelectorAll('[data-cart-total] .cart-total-grandtotal');
      var freshTotal = doc.querySelector('[data-cart-total] .cart-total-grandtotal');
      for (var j = 0; j < totals.length; j++) if (freshTotal) totals[j].innerHTML = freshTotal.innerHTML;
      writeCount(cart);
      announce(cart);
    } catch (e) {
      reloadPage();
    }
  }

  function refresh() {
    if (isCartPage()) { refreshCartPage(); return; }
    var hasElla = window.Shopify && typeof window.Shopify.getCart === 'function' &&
      window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function';
    muted = Date.now() + 4000;
    if (hasElla) {
      window.Shopify.getCart(function (cart) {
        try { window.sharedFunctions.updateSidebarCart(cart); } catch (e) { /* sertarul se redesenează la următoarea deschidere */ }
      });
    }
  }

  /* quiet = true: corectează fără să redeseneze (clientul pleacă spre checkout). */
  async function sync(quiet) {
    if (running) { again = true; return current; }
    running = true;
    clearTimeout(timer);
    timer = null;
    current = run(quiet === true);
    return current;
  }

  async function run(quiet) {
    try {
      var res = await fetch(root + '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      var cart = await res.json();
      var changes = plan(cart.items || []);
      if (!changes.length) {
        try { sessionStorage.removeItem(FLAG); } catch (e) { /* nimic */ }
        return;
      }

      // frâne: pe pagina de coș o singură reîncărcare la rând; la rulările automate, cel mult 3 corecții în 20 s,
      // cu o reîncercare după fereastră. Rulările `quiet` pornesc doar dintr-un clic pe checkout, deci nu pot
      // intra în buclă și nu sunt frânate.
      var now = Date.now();
      recent = recent.filter(function (t) { return now - t < 20000; });
      if (!quiet && recent.length >= 3) {
        if (!retry) retry = setTimeout(function () { retry = null; sync(); }, 20000 - (now - recent[0]) + 100);
        return;
      }
      if (isCartPage() && !quiet) {
        var flagged = false;
        try { flagged = !!sessionStorage.getItem(FLAG); } catch (e) { flagged = false; }
        if (flagged) return;
      }
      recent.push(now);

      for (var i = 0; i < changes.length; i++) {
        var upd = await post({ id: changes[i].key, quantity: changes[i].quantity });
        if (!upd.ok) return;
      }
      if (!quiet) { redraw = false; refresh(); }
    } catch (err) {
      /* coșul rămâne cum e */
    } finally {
      running = false;
      current = null;
      if (redraw && !quiet) { redraw = false; refresh(); }
      if (again) { again = false; schedule(); }
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { timer = null; sync(); }, 300);
  }

  /* Garda de checkout: o ultimă verificare (sau cea deja în curs), apoi clicul merge mai departe la Ella.
     Nu blochează niciodată: eroare sau depășirea timpului = checkout-ul pornește oricum. */
  function settle() {
    var job = running && current ? current : sync(true);
    var limit = new Promise(function (resolve) { setTimeout(resolve, WAIT); });
    return Promise.race([Promise.resolve(job).catch(function () {}), limit]);
  }

  document.addEventListener('click', function (event) {
    if (passing) return;
    var target = event.target;
    var button = target && target.closest ? target.closest(CHECKOUT) : null;
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    settle().then(function () {
      button.removeAttribute('aria-busy');
      passing = true;
      try { button.click(); } finally { passing = false; }
    });
  }, true);

  /* Regiunea live: #cart-live-region-text pe pagina de coș, [data-gf-cart-status] în sertar (când e deschis). */
  function say() {
    var page = isCartPage();
    if (!page && !document.body.classList.contains('cart-sidebar-show')) return;
    var region = page ? document.getElementById('cart-live-region-text') : document.querySelector('[data-gf-cart-status]');
    var scope = page ? document.getElementById('main-cart-items') : document.getElementById('halo-cart-sidebar');
    if (!region || !scope) return;
    var total = scope.querySelector(page ? '[data-cart-total] .cart-total-grandtotal' : '.previewCartTotals.total');
    var bar = scope.querySelector('.gf-shipbar__text');
    var parts = [];
    if (total) parts.push(total.textContent.replace(/\s+/g, ' ').trim());
    if (bar) parts.push(bar.textContent.replace(/\s+/g, ' ').trim());
    var text = parts.filter(Boolean).join('. ');
    if (region.textContent !== text) region.textContent = text;
  }

  document.addEventListener('cart-update', function () {
    say();
    if (Date.now() < muted) { muted = 0; return; } // actualizarea provocată de propria corecție (una singură)
    schedule();
  });

  /* Coșul s-a schimbat pe server fără ca pagina de coș să fie redesenată (global.js, ramura de eroare):
     corectăm add-on-ul și redesenăm oricum. preventDefault = „ne ocupăm noi”, altfel Ella reîncarcă pagina. */
  document.addEventListener('gf:cart-stale', function (event) {
    if (!isCartPage()) return;
    event.preventDefault();
    redraw = true;
    if (running) again = true;
    else sync();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sync(); }, { once: true });
  else sync();
})();
